import { BASE_URL, STORAGE_SUF } from "../constants"
import { fetchWithAuth } from "../utils/fetchWithAuth"

const suffix = localStorage.getItem(STORAGE_SUF) || ""

export const getUploadedFiles = async (category: string): Promise<string[]> => {
  try {
    const response = await fetchWithAuth(
      `${BASE_URL}/uploaded-files-${suffix}?category=${encodeURIComponent(category)}`,
    )

    if (!response.ok) {
      throw new Error(`Failed to fetch uploaded files`)
    }

    return await response.json()
  } catch (error) {
    console.error(`Error fetching uploaded files`, error)
    throw error
  }
}

export const deleteUploadedFile = async (
  category: string,
  fileName: string,
): Promise<void> => {
  try {
    const response = await fetchWithAuth(`${BASE_URL}/uploaded-files-${suffix}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ category, fileName }),
    })

    if (!response.ok) {
      throw new Error(`Failed to delete backup file`)
    }
  } catch (error) {
    console.error(`Error deleting backup file`, error)
    throw error
  }
}
